import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Signin from '../views/Signin.vue'

// import Main from '../views/Main.vue'
import Main from '../views/2021Main.vue'

import MainGroup from '../views/MainGroup.vue'
// import WIPDocument from '../views/WIPDocument.vue'
// import WIPSample from '../views/WIPSample.vue'
// import WIPFab from '../views/WIPFab.vue'
// import WIPFab from '../views/2021WipFab.vue'
// import WIPSew from '../views/WIPSewNew.vue'

// import WIPPack from '../views/WIPPackNew.vue'
import WIPFC from '../views/WIPFC.vue'
import WIPPattern from '../views/WIPPattern.vue'
import flask from '../views/testFlask.vue'

import MainWIPProduction from '../views/MainWIPProduction.vue'
import HourlyOutput from '../views/Hourly_output.vue'
// import Page01 from '../views/Page01New'
// import Page02 from '../views/Page02'
// import Page03 from '../views/Page03'
// import Page032 from '../views/Page032'
// import Page04 from '../views/Page04'
// import Page05 from '../views/Page05'
// import Page06 from '../views/Page06'
// import Page07 from '../views/Page07'
// import testfont from '../views/testfont'

import p1 from '../views/OTP/comvnpuma.vue'
import p2 from '../views/OTP/comvnnonpuma.vue'
import p3 from '../views/OTP/procurementvn.vue'
import p4 from '../views/OTP/comnonniketh.vue'
import p5 from '../views/OTP/comnonniketrm.vue'
import p6 from '../views/OTP/comnike.vue'
import p7 from '../views/OTP/procurementnonnike.vue'
import p8 from '../views/OTP/scm.vue'
import p9 from '../views/OTP/comgrw.vue'

import s05 from '../views/Snap/boardEff.vue'
import s051 from '../views/Snap/boardEff_plot.vue'
import s04 from '../views/Snap/boardSM3.vue'
import s07 from '../views/Snap/boardShipment.vue'
import s01 from '../views/Snap/boardPPR.vue'
import s02 from '../views/Snap/boardCut.vue'
import s031 from '../views/Snap/boardInternal.vue'
import s032 from '../views/Snap/boardExternal.vue'

import saletarget from '../views/saletarget.vue'

// const testfont = () => import('../views/testfont.vue' /* webpackChunkName: 'testfont' */)

// const Signin = () => import('../views/ganttchart.vue' /* webpackChunkName: 'Signin' */)
const Signin = () =>
  import('../views/Signin.vue' /* webpackChunkName: 'Signin' */)

// const Page01New = () => import('../views/Page01New.vue' /* webpackChunkName: 'page01' */)
const Page01 = () =>
  import('../views/Page01New.vue' /* webpackChunkName: 'page01' */)
const Page02 = () =>
  import('../views/Page02.vue' /* webpackChunkName: 'page02' */)
const Page02New = () =>
  import('../views/Page02New.vue' /* webpackChunkName: 'page02New' */)
const PlanCutChart = () =>
  import('../views/plan_cut_chart.vue' /* webpackChunkName: 'page02New' */)
const Page03 = () =>
  import('../views/Page03.vue' /* webpackChunkName: 'page03' */)
const Page032 = () =>
  import('../views/Page032.vue' /* webpackChunkName: 'page032' */)
const Page03Internal = () =>
  import(
    '../views/Page03Internal.vue' /* webpackChunkName: 'Page03Internal' */
  )
const Page04 = () =>
  import('../views/Page04new.vue' /* webpackChunkName: 'page04' */)
const Page05 = () =>
  import('../views/Page05.vue' /* webpackChunkName: 'page05' */)
const Page05Pcs = () =>
  import('../views/Page05Pcs.vue' /* webpackChunkName: 'page05' */)
const Page06 = () =>
  import('../views/Page06.vue' /* webpackChunkName: 'page06' */)
const Page07 = () =>
  import('../views/Page07.vue' /* webpackChunkName: 'page07' */)
const Page07New = () =>
import('../views/Page07New.vue' /* webpackChunkName: 'page07' */)
const Page07NewEA = () =>
  import('../views/Page07NewEA.vue' /* webpackChunkName: 'page07' */)

const ReadinessDocument = () =>
  import(
    '../views/ReadinessPage/DOC.vue' /* webpackChunkName: 'ReadinessDocument' */
  )
const ReadinessSample = () =>
  import(
    '../views/ReadinessPage/SAMPLE.vue' /* webpackChunkName: 'ReadinessSample' */
  )
const ReadinessFab = () =>
  import(
    '../views/ReadinessPage/FAB.vue' /* webpackChunkName: 'ReadinessFab' */
  )
const ReadinessSew = () =>
  import(
    '../views/ReadinessPage/SEW.vue' /* webpackChunkName: 'ReadinessSew' */
  )
const ReadinessPack = () =>
  import(
    '../views/ReadinessPage/PACK.vue' /* webpackChunkName: 'ReadinessPack' */
  )

const OTPMerNIKE = () =>
  import('../views/OTPMerNIKE.vue' /* webpackChunkName: 'OTPMerNIKE' */)
const OTPMerVN = () =>
  import('../views/OTPMerVN.vue' /* webpackChunkName: 'OTPMerVN' */)
const OTPMerNONNIKE = () =>
  import('../views/OTPMerNONNIKE.vue' /* webpackChunkName: 'OTPMerNONNIKE' */)
const OTPMerTRM = () =>
  import('../views/OTPMerTRM.vue' /* webpackChunkName: 'OTPMerTRM' */)

const Calendar = () =>
  import('../views/calendar.vue' /* webpackChunkName: 'Calendar' */)
const CutSpeed = () =>
  import('../views/CutSpeed.vue' /* webpackChunkName: 'CutSpeed' */)
const DailyCut = () =>
  import('../views/DailyCut.vue' /* webpackChunkName: 'DailyCut' */)

const Department = () =>
  import('../views/department.vue' /* webpackChunkName: 'Department' */)

// const OTPScm = () => import('../views/OTPSCM.vue' /* webpackChunkName: 'OTPSCM' */)
// const OTPProcurement = () => import('../views/OTPProcurement.vue' /* webpackChunkName: 'OTPProcurement' */)
// const OTPNike = () => import('../views/OTPNIKE.vue' /* webpackChunkName: 'OTPNIKE' */)

Vue.use(VueRouter)

const routes = [
  {
    path: '/saletarget',
    name: 'saletarget',
    component: saletarget
  },
  {
    path: '/s01',
    name: 's01',
    component: s01
  },
  {
    path: '/s02',
    name: 's02',
    component: s02
  },
  {
    path: '/s031',
    name: 's031',
    component: s031
  },
  {
    path: '/s032',
    name: 's032',
    component: s032
  },
  {
    path: '/s04',
    name: 's04',
    component: s04
  },
  {
    path: '/s05',
    name: 's05',
    component: s05
  },
  {
    path: '/s07',
    name: 's07',
    component: s07
  },

  {
    path: '/s051',
    name: 's051',
    component: s051
  },
  {
    path: '/p1',
    name: 'p1',
    component: p1
  },
  {
    path: '/p2',
    name: 'p2',
    component: p2
  },
  {
    path: '/p3',
    name: 'p3',
    component: p3
  },
  {
    path: '/p4',
    name: 'p4',
    component: p4
  },
  {
    path: '/p5',
    name: 'p5',
    component: p5
  },
  {
    path: '/p6',
    name: 'p6',
    component: p6
  },
  {
    path: '/p7',
    name: 'p7',
    component: p7
  },
  {
    path: '/p8',
    name: 'p8',
    component: p8
  },
  {
    path: '/p9',
    name: 'p9',
    component: p9
  },

  {
    path: '/WIPDocument/:grp/:team',
    name: 'WIPDocument',
    component: ReadinessDocument
  },
  {
    path: '/WIPSample/:grp/:team',
    name: 'WIPSample',
    component: ReadinessSample
  },
  {
    path: '/WIPFab/:grp/:loc',
    name: 'WIPFab',
    component: ReadinessFab
  },
  {
    path: '/WIPSew/:grp/:loc',
    name: 'WIPSew',
    component: ReadinessSew
  },
  {
    path: '/WIPPack/:grp/:loc',
    name: 'WIPPack',
    component: ReadinessPack
  },
  {
    path: '/OTPMerNIKE',
    name: 'OTPMerNIKE',
    component: OTPMerNIKE
  },
  {
    path: '/OTPMerVN',
    name: 'OTPMerVN',
    component: OTPMerVN
  },
  {
    path: '/OTPMerNONNIKE',
    name: 'OTPMerNONNIKE',
    component: OTPMerNONNIKE
  },
  {
    path: '/OTPMerTRM',
    name: 'OTPMerTRM',
    component: OTPMerTRM
  },
  {
    path: '/Calendar/:grp',
    name: 'Calendar',
    component: Calendar
  },
  {
    path: '/CutSpeed',
    name: 'CutSpeed',
    component: CutSpeed
  },
  {
    path: '/DailyCut/:loc',
    name: 'DailyCut',
    component: DailyCut
  },
  {
    path: '/Department',
    name: 'Department',
    component: Department
  },
  // {
  //   path: '/OTPSCM',
  //   name: 'OTPSCM',
  //   component: OTPScm
  // },
  // {
  //   path: '/OTPProcurement',
  //   name: 'OTPProcurement',
  //   component: OTPProcurement
  // },
  // {
  //   path: '/OTPNIKE',
  //   name: 'OTPNIKE',
  //   component: OTPNike
  // },
  // {
  //   path: '/WIPDocument/:loc/:team',
  //   name: 'WIPDocument',
  //   component: WIPDocument
  // },
  {
    path: '/flask',
    name: 'flask',
    component: flask
  },

  {
    path: '/',
    name: 'signin',
    component: Signin
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/maingroup',
    name: 'MainGroup',
    component: MainGroup
  },
  {
    path: '/main',
    name: 'main',
    component: Main
  },

  // {
  //   path: '/WIPSew/:grp/:loc',
  //   name: 'WIPSew',
  //   component: WIPSew
  // },
  // {
  //   path: '/WIPPack/:grp/:loc',
  //   name: 'WIPPack',
  //   component: WIPPack
  // },
  {
    path: '/WIPFC/:grp',
    name: 'WIPFC',
    component: WIPFC
  },
  {
    path: '/WIPPattern/:grp',
    name: 'WIPPattern',
    component: WIPPattern
  },
  {
    path: '/MainWIPProduction',
    name: 'MainWIPProduction',
    component: MainWIPProduction
  },
  {
    path: '/HourlyOutput',
    name: 'HourlyOutput',
    component: HourlyOutput
  },
  {
    path: '/Page01',
    name: 'Page01',
    component: Page01
    // component: () => import(/* webpackChunkName: 'page01' */ '../views/Page01.vue')
  },
  // {
  //   path: '/Page01New',
  //   name: 'Page01New',
  //   component: Page01New
  //   // component: () => import(/* webpackChunkName: 'page01' */ '../views/Page01.vue')
  // },
  // {
  //   path: '/Page01New',
  //   name: 'Page01New',
  //   component: Page01New
  //   // component: () => import(/* webpackChunkName: 'page01' */ '../views/Page01.vue')
  // },
  {
    path: '/Page02',
    name: 'Page02',
    component: Page02
  },
  {
    path: '/Page02New',
    name: 'Page02New',
    component: Page02New
  },
  {
    path: '/PlanCutChart',
    name: 'PlanCutChart',
    component: PlanCutChart
  },
  {
    path: '/Page03',
    name: 'Page03',
    component: Page03
  },
  {
    path: '/Page03Internal',
    name: 'Page03Internal',
    component: Page03Internal
  },
  {
    path: '/Page032',
    name: 'Page032',
    component: Page032
  },
  {
    path: '/Page04',
    name: 'Page04',
    component: Page04
  },
  {
    path: '/Page05',
    name: 'Page05',
    component: Page05
  },
  {
    path: '/Page05Pcs',
    name: 'Page05Pcs',
    component: Page05Pcs
  },
  {
    path: '/Page06',
    name: 'Page06',
    component: Page06
  },
  {
    path: '/Page07',
    name: 'Page07',
    component: Page07
    // component: () => import(/* webpackChunkName: 'page07' */ '../views/Page07.vue')
  },
  {
    path: '/Page07New',
    name: 'Page07New',
    component: Page07New
    // component: () => import(/* webpackChunkName: 'page07' */ '../views/Page07.vue')
  },
  {
    path: '/Page07NewEA',
    name: 'Page07NewEA',
    component: Page07NewEA
    // component: () => import(/* webpackChunkName: 'page07' */ '../views/Page07.vue')
  }
  // ,{
  //   path: '/about2',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: 'about' */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
